<template>
    <router-view></router-view>
    <PreviewStatus v-if="preview" />
</template>

<script>
import PreviewStatus from './components/PreviewStatus.vue';
export default {
  name: 'App',
  components: { PreviewStatus },
  data: () => ({ preview: process.env.VUE_APP_PREVIEW === 'true' })
};
</script>
